import { ProviderClientProperty } from '~/plugins/data-connector/types/provider.types'
import { FormCommonType } from './strategy.form.common'

type OptionsClient = FormCommonType & {
  inputs: ProviderClientProperty[]
}

type ResponseClient = FormCommonType & {
  inputs: ProviderClientProperty[]
}

export function FormClient(options: OptionsClient): ResponseClient {
  return {
    ...options,
  }
}

export type FormClientType = ReturnType<typeof FormClient>
